import { create } from 'zustand'

let nextId = 0

export const useToastStore = create((set, get) => ({
  toasts: [],

  addToast: (type, message, duration = 4000) => {
    const id = ++nextId
    const toast = { id, type, message, duration }
    set((s) => ({ toasts: [...s.toasts.slice(-2), toast] })) // max 3

    if (duration > 0) {
      setTimeout(() => get().removeToast(id), duration)
    }
    return id
  },

  removeToast: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
  },
}))
